import { readonly } from 'vue';
import { useTitle } from '@vueuse/core';

const windowTitle = useTitle();

/**
 * Gère le titre de l'onglet du navigateur (`document.title`).
 *
 * Important : `document.title` est lu par GTM (variable " Page Title " de GA4), il ne doit donc
 * JAMAIS contenir de renseignements personnels, seulement des titres génériques.
 */
export default function useWindowTitle() {
  function setWindowTitle(newTitle: string) {
    // On ignore les chaînes vides pour ne pas effacer le titre.
    if (newTitle) {
      windowTitle.value = newTitle;
    }
  }

  return {
    setWindowTitle,
    windowTitle: readonly(windowTitle),
  };
}
